/**
 * Deal-owner helpers (Super Admin only) — maps SSP deal_ids to users who may
 * see that deal's data in marketplace reporting.
 */
import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL + "/api";
const base = `${API}/reporting/marketplace/deal-owners`;

export const listOwnerUsers = (token) =>
  axios.get(`${base}/users`, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data);

export const setDealOwners = (token, dealId, userIds) =>
  axios.put(`${base}/${encodeURIComponent(dealId)}`, { user_ids: userIds }, {
    headers: { Authorization: `Bearer ${token}` },
  }).then((r) => r.data);

export const bulkSetDealOwners = (token, dealIds, userIds, mode) =>
  axios.post(`${base}/bulk`, { deal_ids: dealIds, user_ids: userIds, mode }, {
    headers: { Authorization: `Bearer ${token}` },
  }).then((r) => r.data);

export const shortUserLabel = (u) => (u ? (u.name || u.email.split("@")[0]) : "Unknown");
export const fullUserLabel = (u) => (u ? `${u.name || u.email} (${u.email})` : "Unknown");
